/* eslint-disable spire/export-styles */
import loadExternalProvidersWithReturn from "@husky-hrc/Framework/Handlers/Data/SignIn/LoadExternalProviders";
import { getExternalProvidersByUrl } from "@husky-hrc/Framework/Store/Data/SignIn/SignInSelector";
import ExtendedApplicationState from "@husky-hrc/Framework/Store/ExtendedApplicationState";
import { redirectToAuthProviderUrl } from "@husky-hrc/Utilities/HuskyExternalAuth";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import signOut from "@insite/client-framework/Store/Context/Handlers/SignOut";
import { getLocation, removeAbsoluteUrl } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps {
    label: string;
    extendedStyles?: SignInLinkStyles;
}

export interface SignInLinkStyles {
    clickableStyles?: ClickablePresentationProps;
    typographyStyles?: TypographyPresentationProps;
}

const signInStyles: SignInLinkStyles = {};

const mapStateToProps = (state: ExtendedApplicationState) => {
    const currentLocation = getLocation(state);
    const returnUrl = removeAbsoluteUrl(currentLocation.pathname);
    return {
        userName: state.context.session.userName,
        returnUrl,
        externalProvidersState: getExternalProvidersByUrl(state, returnUrl),
        currentUserIsGuest: getCurrentUserIsGuest(state),
    };
};

const mapDispatchToProps = {
    signOut,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const SignInLink: React.FC<Props> = ({
    userName,
    returnUrl,
    externalProvidersState,
    currentUserIsGuest,
    signOut,
    label,
    extendedStyles,
}) => {
    const [styles] = React.useState(() => mergeToNew(signInStyles, extendedStyles));

    React.useEffect(() => {
        if (!userName && !externalProvidersState.value && !externalProvidersState.isLoading) {
            loadExternalProvidersWithReturn({ returnUrl });
        }
    }, [returnUrl]);

    const handleClick = () => {
        if (userName && !currentUserIsGuest) {
            signOut();
        } else {
            redirectToAuthProviderUrl(externalProvidersState.value!.externalProviders);
        }
    };

    return (
        <Clickable {...styles.clickableStyles} onClick={handleClick}>
            <Typography {...styles.typographyStyles}>
                {translate(userName && !currentUserIsGuest ? "Sign Out" : label)}
            </Typography>
        </Clickable>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(SignInLink);
